var n = (r, t, o) => new Promise((p, c) => {
  var i = (e) => {
    try {
      a(o.next(e));
    } catch (s) {
      c(s);
    }
  }, l = (e) => {
    try {
      a(o.throw(e));
    } catch (s) {
      c(s);
    }
  }, a = (e) => e.done ? p(e.value) : Promise.resolve(e.value).then(i, l);
  a((o = o.apply(r, t)).next());
});
import { selfAxios as d } from "@oppein/op-utils";
function m(r) {
  return n(this, null, function* () {
    const {
      data: t
    } = yield d.post(
      "/designordercenter/productionOrder/specialApply/createRelocateBase",
      r
    );
    return t == null ? void 0 : t.data;
  });
}
export {
  m as postCreateRelocateBase
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/request/designordercenter/productionOrder/specialApply/createRelocateBase/post.js
// module id = 1823
// module chunks = 67